module.exports = __webpack_public_path__ + "img/n_cj2.4a18c95e.png";